module.exports = __webpack_public_path__ + "img/shop1.497f7bae.jpg";